import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React, { createRef } from 'react';
import ReactSwipe from 'react-swipe';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import s from './SwipeSlider.scss';
const MAX_CHILDREN_COUNT = 5;
const SWIPE_STYLES = {
    container: {
        overflow: 'hidden',
        position: 'relative'
    },
    wrapper: {
        overflow: 'hidden',
        position: 'relative'
    },
    child: {
        float: 'left'
    }
};
export class SwipeSlider extends React.Component {
    componentDidMount() {
        this.setState({
            mounted: true
        });
        if (this.props.goToNextInterval) {
            this.goToNextSlideAfterTimeout();
        }
    }
    componentDidUpdate() {
        this.goToNextSlideAfterTimeout();
    }
    static getDerivedStateFromProps(props, state) {
        const items = SwipeSlider.getItems(props.children);
        if (state.activeIndex > items.length - 1) {
            return {
                activeIndex: items.length - 1
            };
        }
        return null;
    }
    static getItems(children) {
        return React.Children.count(children) > MAX_CHILDREN_COUNT ? React.Children.toArray(children).slice(0, MAX_CHILDREN_COUNT) : React.Children.toArray(children);
    }
    render() {
        const { indicatorsClassName, children } = this.props;
        const { activeIndex, mounted } = this.state;
        const items = SwipeSlider.getItems(children);
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], !mounted && s['not-mounted'])
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "SwipeSlider"
        }, /*#__PURE__*/ React.createElement(ReactSwipe, {
            ref: this.reactSwipeEl,
            swipeOptions: {
                startSlide: activeIndex,
                callback: this.onSlideChange
            },
            style: SWIPE_STYLES
        }, items.map((child, index)=>/*#__PURE__*/ React.createElement("div", {
                key: child ? child['key'] : index,
                className: classnames(s['child'], index === activeIndex && s['active'])
            }, child))), items.length > 1 && /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['indicators'], indicatorsClassName)
        }, items.map((_, index)=>/*#__PURE__*/ React.createElement("div", {
                key: index,
                className: classnames(s['indicator'], index === activeIndex && s['active']),
                onClick: ()=>{
                    this.setState({
                        activeIndex: index,
                        stopRotation: true
                    }, ()=>this.reactSwipeEl.current && this.reactSwipeEl.current.slide(this.state.activeIndex, 0));
                }
            })))));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            activeIndex: 0,
            stopRotation: false,
            mounted: false
        });
        _define_property(this, "reactSwipeEl", /*#__PURE__*/ createRef());
        _define_property(this, "timer", void 0);
        _define_property(this, "goToNextSlideAfterTimeout", ()=>{
            clearTimeout(this.timer);
            if (this.state.stopRotation || !this.props.goToNextInterval) {
                return;
            }
            this.timer = setTimeout(()=>{
                const items = SwipeSlider.getItems(this.props.children);
                if (items.length < 2) {
                    return;
                }
                let nextIndex = this.state.activeIndex + 1;
                if (nextIndex >= items.length) {
                    nextIndex = 0;
                }
                this.setState({
                    activeIndex: nextIndex
                });
                this.goToNextSlideAfterTimeout();
            }, this.props.goToNextInterval);
        });
        _define_property(this, "onSlideChange", (index)=>{
            if (!this.props.goToNextInterval) {
                this.setState({
                    activeIndex: index
                });
            }
        });
    }
}
export default SwipeSlider;

//# sourceMappingURL=SwipeSlider.js.map